<template>
  <hic-list-page title="用户管理" keyword-placeholder="请输入名称或者登入名" :entities="entities" :condition="condition" @ok="page" @load="page" :loading="meta.loading" ref="listPage">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small" v-if="permission.masterdata_staff_create">
        <i class="el-icon-plus"></i>
        新建
      </el-button>
    </template>
    <template slot="search">
      <el-switch v-model="condition.searchType" active-text="已删除" active-value="被删除" inactive-text="全部" inactive-value="全部" @change="page"></el-switch>
    </template>
    <el-table-column v-if="permission.masterdata_staff_edit || permission.masterdata_staff_delete || permission.masterdata_staff_role" label="操作" width="150" align="center" fixed="left">
      <template slot-scope="scope">
        <el-button v-if="permission.masterdata_staff_edit && scope.row.id" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" :disabled="scope.row.deleted" />
        <hic-regret-button v-if="permission.masterdata_staff_delete && scope.row.id && !scope.row.deleted" type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
        <hic-regret-button v-if="permission.masterdata_staff_delete && scope.row.id && scope.row.deleted" type="danger" icon="el-icon-news" circle plain @click="recover(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
        <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
        <el-button v-if="permission.masterdata_staff_role && scope.row.id" type="success" icon="el-icon-coordinate" circle plain size="mini" @click="bingRole(scope.row)" class="left-pad" :disabled="scope.row.deleted" />
      </template>
    </el-table-column>
    <el-table-column label="姓名" prop="name" min-width="100" fixed="left" sortable="custom">
      <template slot-scope="{ row }">
        <b :title="row.code">{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="科室" prop="deptCode" min-width="120" align="left" :filters="dict.Dept" :filter-multiple="false" column-key="deptCode">
      <template slot-scope="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column label="类型" prop="account" min-width="100" align="center" :filters="dict.StaffType" :filter-multiple="false" column-key="type">
      <template slot-scope="{ row }">
        {{ row.type | dictText("StaffType") }}
      </template>
    </el-table-column>
    <el-table-column label="专家" width="60" align="center" :filters="meta.ifOptions" :filter-multiple="false" column-key="ifExpert">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifExpert" type="success" effect="plain" size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="在线" prop="ifOnline" width="60" align="center" :filters="meta.ifOptions" :filter-multiple="false" column-key="ifOnline">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifOnline" effect="plain" size="mini">是</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="锁定" width="60" align="center" :filters="meta.ifOptions" :filter-multiple="false" :filter-method="filterHandler" :column-key="columnKey">
      <template slot-scope="{ row }">
        <el-tag v-if="row.locked" type="danger" effect="plain" size="mini">是</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="删除" prop="deleted" width="60" align="center" :filters="meta.ifOptions" :filter-multiple="false" column-key="deleted">
      <template slot-scope="{ row }">
        <el-tag v-if="row.deleted" type="danger" effect="plain" size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="兼职科室" prop="deptCode" min-width="120" align="center">
      <template slot-scope="{ row }" v-if="(JSON.parse(row.deptCodes) || []).filter((d) => d != row.deptCode).length > 0">
        <span v-for="dept in JSON.parse(row.deptCodes).filter((d) => d != row.deptCode)" type="info" :key="dept" effect="plain" size="mini" class="left-pad">{{ dept | dictText("Dept") }}</span>
      </template>
    </el-table-column>
    <el-table-column label="登录名" prop="account" min-width="100" align="center" sortable="custom"></el-table-column>
    <el-table-column label="性别" prop="gender" width="60" show-overflow-tooltip align="center" :filters="dict.Gender" :filter-multiple="false" column-key="gender">
      <template slot-scope="{ row }">
        {{ row.gender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="头像" prop="avator" min-width="50">
      <template slot-scope="{ row }">
        <img v-if="row.avatar" :src="row.avatar" width="25" height="25" />
        <el-avatar v-else shape="square" :size="25" icon="el-icon-user-solid" />
      </template>
    </el-table-column>
    <el-table-column label="生日" prop="birthday" min-width="100" align="right">
      <template slot-scope="scope">
        {{ scope.row.birthday | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column label="手机" prop="phone" min-width="120" align="center"></el-table-column>
    <el-table-column label="邮箱" prop="email"></el-table-column>
    <el-table-column label="住址" prop="address" show-overflow-tooltip></el-table-column>
    <el-table-column label="注册" prop="joinDate" min-width="100" align="right">
      <template slot-scope="scope">
        {{ scope.row.joinDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column label="访问次数" prop="visits" align="right" width="100" sortable="custom"></el-table-column>
    <el-table-column label="最后登录" prop="last" min-width="100" align="right" width="100" sortable="custom">
      <template slot-scope="scope">
        {{ scope.row.last | fmtDate }}
      </template>
    </el-table-column>
    <staff-edit :visible.sync="showEditor" :staff="entity" @ok="ok" />
    <roles-edit :visible.sync="showRoles" :staff="entity" />
  </hic-list-page>
  <!-- <el-container class="f-h">
    <el-header style="height: 5rem">
      <p class="sub-title">用户管理</p>
      <el-row>
        <el-col :span="4" class="left">
          <el-button type="primary" @click="create" size="small" v-if="permission.masterdata_staff_create"> <i class="el-icon-plus"></i> 新建 </el-button>
        </el-col>
        <el-col :span="4" class="right">
          <el-switch v-model="condition.searchType" active-text="已删除" active-value="被删除" inactive-text="全部" inactive-value="全部" @change="page"></el-switch>
        </el-col>
        <el-col :span="16" class="right">
          <hic-dict-selector v-model="condition.deptCode" dict-type="Dept" class="condition-wide" @change="page" />
          <el-input v-model="condition.keyword" placeholder="请输入名称或登录名" size="small" v-on:keyup.enter.native="page" class="condition-wide left-pad" clearable @clear="page">
            <el-button :loading="loading" slot="append" icon="el-icon-search" @click="page"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table v-loading="loading" height="100%" :data="entities.items" row-key="id" @filter-change="filterChanged" class="main-table">
      </el-table>
    </el-main>
    <el-footer style="height: 2.5rem">
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="page" @current-change="page" :current-page.sync="condition.pageIndexOnView" :page-size.sync="condition.pageSize" :total="entities.total"></el-pagination>
    </el-footer>
  </el-container> -->
</template>

<script>
  import api from "./api.js";
  import store from "@/common/store";
  // import cfg from "@/common/cfg"
  import { mapGetters } from "sw-hic";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_staff_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    components: {
      "roles-edit": () => import("./roles"),
      "staff-edit": () => import("./edit"),
    },
    data() {
      return {
        columnKey: "nulls",
        showEditor: false,
        showRoles: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          deptCode: null,
          sort: "id",
          asc: false,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        meta: {
          loading: false,
          ifOptions: [
            { text: "是", value: true },
            { text: "否", value: false },
          ],
        },

        editingIndex: -1,
      };
    },
    computed: {
      ...mapGetters(["dict", "permission"]),
    },
    // created() {
    //   this.$store.dispatch("loadDicts", ["Dept", "Gender", "StaffType", "DoctorPosition"]);
    // },
    methods: {
      filterHandler(value, row, column) {
        this.columnKey = value ? "notNulls" : "nulls";
      },
      page() {
        let _this = this;
        this.meta.loading = true;
        api.Staff.query(this.condition)
          .then((res) => {
            _this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            _this.meta.loading = false;
          });
      },
      create() {
        this.editingIndex = 0;
        this.entity = {
          id: null,
          joinDate: this.$utils.Dt.now(),
        };
        this.showEditor = true;
      },
      edit(row, index) {
        this.editingIndex = index;
        this.entity = this.$utils.Obj.clone(row);
        this.entity.password = null;
        this.showEditor = true;
      },
      ok(newEntity) {
        this.page();
        // if (this.editingIndex != -1) {
        //   this.entities.items.splice(this.editingIndex, 1, newEntity);
        // } else {
        //   this.entities.items.unshift(newEntity);
        // }
        // this.editingIndex == -1;
      },
      del(row, index) {
        let _this = this;
        api.Staff.del(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
          _this.page();
        });
      },
      recover(row, index) {
        let _this = this;
        api.Staff.recovery(row.id).then((res) => {
          _this.$message.success("删除恢复成功！");
          _this.page();
        });
      },
      bingRole(row) {
        this.entity = row;
        this.showRoles = true;
      },
      filterChanged(options) {
        options[Object.keys(options)[0]] = Object.values(options)[0][0];
        Object.assign(this.condition, options);
        this.page();
      },
    },
  };
</script>
